import { observer } from 'mobx-react-lite';
import { Alert, Button } from '@mui/material';

import { useTopicStore } from '@/dmdrive/topic/components/Topic/TopicStore';

import { NoRemarksWrapper, RemarksHeader, RemarksList, RemarksListContent, RemarksRoot } from './Remarks.styles';

import RemarkRow from './RemarkRow/RemarkRow';

function Remarks() {
  const { topic, deleteAllMarks } = useTopicStore();

  if (!topic?.marks || topic.marks.length === 0) {
    return (
      <NoRemarksWrapper>
        <Alert icon={false} severity="warning">
          No remarks here
        </Alert>
      </NoRemarksWrapper>
    );
  }

  return (
    <RemarksRoot>
      {topic.marks.length > 0 && (
        <RemarksHeader>
          <Button size="small" variant="outlined" color="error" onClick={deleteAllMarks}>
            Remove all
          </Button>
        </RemarksHeader>
      )}

      <RemarksList>
        <RemarksListContent>
          {topic.marks.map((mark) => (
            <RemarkRow key={mark.id} mark={mark} />
          ))}
        </RemarksListContent>
      </RemarksList>
    </RemarksRoot>
  );
}

export default observer(Remarks);
